import Vue from 'vue'
import App from './App'
import router from './router'
import 'normalize.css/normalize.css'
import store from './store/index'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/js/rem.js'
import 'animate.css'
import 'vant/lib/index.css';
Vue.use(ElementUI);   
Vue.config.productionTip = false

import md5 from 'js-md5' //引入
 
Vue.prototype.$md5 = md5;//添加
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js